import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { features } from '../data/mock';

export default function FeaturesPage() {
  const [filter, setFilter] = useState('all');
  const [q, setQ] = useState('');
  const filtered = features.filter(f => {
    if (filter === 'res' && !f.residential) return false;
    if (filter === 'com' && !f.commercial) return false;
    if (q && !f.name.toLowerCase().includes(q.toLowerCase()) && !f.desc.toLowerCase().includes(q.toLowerCase())) return false;
    return true;
  });
  return (
    <div className="bg-white">
      <Header />
      <section className="bg-gradient-to-b from-slate-50 to-white pt-16 pb-12">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <p className="text-[#8BC53F] font-bold tracking-widest text-sm mb-3">FEATURES</p>
          <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight text-slate-900">All The Features You Need</h1>
          <p className="mt-6 text-slate-600 text-xl">A complete platform built for residential and commercial pest control operators.</p>
          <div className="mt-8 max-w-xl mx-auto flex gap-2">
            <Input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search features..." className="h-12"/>
            <Button className="bg-[#8BC53F] hover:bg-[#6FA82C] h-12 px-6"><Icons.Search className="w-5 h-5"/></Button>
          </div>
          <div className="mt-6 flex justify-center gap-2 flex-wrap">
            {[{k:'all',l:'All Features'},{k:'res',l:'Residential'},{k:'com',l:'Commercial'}].map(t => (
              <button key={t.k} onClick={()=>setFilter(t.k)} className={`px-5 py-2 rounded-full text-sm font-semibold transition ${filter===t.k ? 'bg-slate-900 text-white' : 'bg-white border border-slate-200 text-slate-700 hover:border-slate-400'}`}>{t.l}</button>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map(f => {
            const Ico = Icons[f.icon] || Icons.Check;
            return (
              <div key={f.name} className="pp-lift group bg-white border border-slate-200 rounded-xl p-6 hover:border-[#8BC53F]">
                <div className="w-12 h-12 rounded-lg bg-[#8BC53F]/10 group-hover:bg-[#8BC53F] text-[#8BC53F] group-hover:text-white flex items-center justify-center transition">
                  <Ico className="w-6 h-6" />
                </div>
                <h4 className="font-bold text-slate-900 text-lg mt-4">{f.name}</h4>
                <p className="text-sm text-slate-600 mt-1 leading-relaxed">{f.desc}</p>
                <div className="flex gap-2 mt-3">
                  {f.residential && <span className="text-[10px] font-bold tracking-wider text-[#8BC53F] bg-[#8BC53F]/10 px-2 py-0.5 rounded">RESIDENTIAL</span>}
                  {f.commercial && <span className="text-[10px] font-bold tracking-wider text-[#6FA82C] bg-[#6FA82C]/10 px-2 py-0.5 rounded">COMMERCIAL</span>}
                </div>
              </div>
            );
          })}
          {filtered.length === 0 && (
            <div className="col-span-full text-center py-16 text-slate-500">No features match your search.</div>
          )}
        </div>
      </section>

      <section className="py-16 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-extrabold tracking-tight">Ready to see Xpertpests in action?</h2>
          <p className="mt-3 text-slate-300">Get a personalized demo and discover how Xpertpests can transform your business.</p>
          <div className="mt-7 flex gap-3 justify-center">
            <Button asChild className="bg-[#F59E0B] hover:bg-[#D4870A] text-slate-900 h-12 px-7 font-bold">
              <Link to="/pricing">Get Started</Link>
            </Button>
            <Button asChild variant="outline" className="border-white text-white bg-transparent hover:bg-white/10 h-12 px-7">
              <Link to="/login">Book a Demo</Link>
            </Button>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
